import { browser } from '$app/environment';
import { get, writable, type Subscriber, type Writable } from 'svelte/store';
import asyncHooks from 'node:async_hooks';

type WritableSession = Writable<App.Session> & { get: () => App.Session };

// Create the session store that is consumable when we are in the client context
function createClientSession() {
  const store: Writable<App.Session> = writable({} as App.Session);
  return {
    set: store.set,
    subscribe: store.subscribe,
    update: store.update,
    get: () => get(store)
  } as WritableSession;
}

// Create the session store within the server context that is backed by our isolated namespace.
function createServerSession() {
  function noop() {
    /* noop */
  }
  const result: WritableSession = {
    set: noop,
    update: noop,
    subscribe: (fn: Subscriber<App.Session>) => {
      const sessionValue = sessionStore.getStore();
      fn(sessionValue);
      return noop;
    },
    get: () => {
      return sessionStore.getStore();
    }
  };
  return result;
}

// Return the appropriate session store based on the context.
export const session: WritableSession = browser ? createClientSession() : createServerSession();
export const sessionStore = !browser && new asyncHooks.AsyncLocalStorage<App.Session>();
